import { passwordStrength } from '../../lib/passwordStrength';

const COLORS = ['bg-ui-border', 'bg-ui-danger', 'bg-ui-warning', 'bg-ui-success'];

// Feedback en vivo de fuerza de contraseña, montado por PasswordField en modo "create".
// No bloquea el envío — solo orienta mientras se escribe.
export default function PasswordStrengthMeter({ password, id }: { password: string; id?: string }) {
  if (!password) return null;
  const { score, label } = passwordStrength(password);

  return (
    <div id={id} role="status" aria-live="polite" aria-label={`Fuerza de la contraseña: ${label}`} className="mt-1.5 flex items-center gap-2">
      <div aria-hidden="true" className="flex flex-1 gap-1">
        {[1, 2, 3].map((step) => (
          <span
            key={step}
            className={`h-1.5 flex-1 rounded-full ${step <= score ? COLORS[score] : 'bg-ui-border'}`}
          />
        ))}
      </div>
      <span aria-hidden="true" className="text-sm text-ui-text-subtle">{label}</span>
    </div>
  );
}
